var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loadingFlag)?_c('van-loading',{staticClass:"vanLoading",attrs:{"type":"spinner","color":"#1989fa"}}):_vm._e(),_c('van-overlay',{staticClass:"vanOverlay",attrs:{"show":_vm.loadingFlag}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }